import React from 'react';
import { Heading, useToast } from '@chakra-ui/react';
import { Formik } from 'formik';
import { localise } from '../../../../services/lang/lang';
import EditOrganisation from '../../../forms/EditOrganisation/EditOrganisation';
import { useUpdateOrganisation } from '../../../../services/api/generated/client';
import useCanUserViewFeature from '../../../../hooks/useCanUserViewFeature';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { FormContainer } from '../../../modules/Form/FormContainer';
const GeneralPage = ({ organisation }) => {
    const toast = useToast();
    const updateOrganisation = useGenericMutationUseCase(useUpdateOrganisation);
    const { canView: userCanUpdateOrganisation } = useCanUserViewFeature([
        'organisations.update',
    ]);
    const onSubmit = (values, helpers) => {
        updateOrganisation.execute({
            id: organisation.id,
            data: {
                contact_phone: values.contact_phone,
                contact_url: values.contact_url,
                contact_email: values.contact_email,
            },
        }, helpers, {
            onSuccess: () => {
                toast({
                    title: localise('ORGANISATION_UPDATED'),
                    status: 'success',
                    isClosable: true,
                });
            },
        });
    };
    const initialValues = {
        name: organisation.name,
        contact_url: organisation.contact_url,
        contact_email: organisation.contact_email,
        contact_phone: organisation.contact_phone,
    };
    return (React.createElement(FormContainer, { "data-testid": "organisation_profile__general-page-form_container" },
        React.createElement(Heading, { as: "h2", variant: "dk-800-lt-4", role: "heading", "data-testid": "organisation_profile__general-page-header" }, localise('GENERAL')),
        React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
            React.createElement(EditOrganisation, { canUserEdit: userCanUpdateOrganisation }))));
};
export default GeneralPage;
